import flatten from 'flat';
import button from './button.json';
import tooltip from './tooltip.json';
import placeholder from './placeholder.json';
import contact from './contact.json';
import notice from './notice.json';
import shared from './shared.json';
import responder from './responder.json';
import dids from './dids.json';
import error from './error.json';
import inbox from './inbox.json';
import ticket from './ticket.json';
import menu from './menu.json';

export default {
  button: flatten(button, {
    delimiter: '_',
  }),
  tooltip: flatten(tooltip, {
    delimiter: '_',
  }),
  placeholder: flatten(placeholder, {
    delimiter: '_',
  }),
  contact: flatten(contact, {
    delimiter: '_',
  }),
  notice: flatten(notice, {
    delimiter: '_',
  }),
  // common label
  shared: flatten(shared, {
    delimiter: '_',
  }),
  responder: flatten(responder, {
    delimiter: '_',
  }),
  dids: flatten(dids, {
    delimiter: '_',
  }),
  error: flatten(error, {
    delimiter: '_',
  }),
  inbox: flatten(inbox, {
    delimiter: '_',
  }),
  ticket: flatten(ticket, {
    delimiter: '_',
  }),
  menu: flatten(menu, {
    delimiter: '_',
  }),
};
